export default __webpack_public_path__ + "c754d236d704cae1129a29eca27f7fdf.jpg";